import { gql, TypedDocumentNode } from '@apollo/client';

import { IGetActivePlansQueryGraphQLResponse, IGetActivePlansQueryVariables } from './useGetActivePlans.interfaces';

const GET_ACTIVE_PLANS_QUERY = gql`
  query getActivePlans($projectId: String!, $product: EProduct!, $currency: ECurrency) {
    plans {
      getActivePlans: getActive(projectId: $projectId, product: $product) {
        id
        productId
        active
        product {
          product
        }
        description
        name
        price(currency: $currency)
        stripePlanId
        sort
        createdAtUtc
        value
      }
    }
  }
` as TypedDocumentNode<IGetActivePlansQueryGraphQLResponse, IGetActivePlansQueryVariables>;

export { GET_ACTIVE_PLANS_QUERY };
